import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { DispatchTrackingService, IDispatch } from '../dispatch-tracking.service';

@Component({
  selector: 'dispatch-completed',
  styleUrls: ['./dispatch-completed.component.scss'],
  templateUrl: './dispatch-completed.component.html',
})
export class DispatchCompletedComponent {
  @Input() public dispatchDetails: IDispatch;
  public isDispatchDeparted = this.dispatchTrackingService.isDispatchDeparted;
  constructor(
    private cdr: ChangeDetectorRef,
    private dispatchTrackingService: DispatchTrackingService,
  ) { }

}
